import React, { useEffect } from 'react';
import styles from './SuccessModal.module.css';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  submittedData?: Record<string, any>;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
  isOpen,
  onClose,
  title,
  message,
  submittedData = {},
}) => {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={handleBackdropClick}>
      <div className={styles.modalContent} role="dialog" aria-modal="true" aria-labelledby="modal-title">
        {/* <button
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close modal"
        >
          ×
        </button> */}

        {/* <div className={styles.successIcon}>✓</div> */}

        <h2 id="modal-title" className={styles.title}>{title}</h2>

        <p className={styles.message}>{message}</p>
{/* 
        {Object.keys(submittedData).length > 0 && (
          <div className={styles.submittedDataSection}>
            <h3 className={styles.dataTitle}>Submitted Information:</h3>
            <div className={styles.dataList}>
              {Object.entries(submittedData).map(([key, value]) => {
                // Skip rendering if value is null, undefined, or empty
                if (value === null || value === undefined || value === '') return null;

                // Format the key for display (camelCase to Title Case)
                const formattedKey = key
                  .replace(/([A-Z])/g, ' $1')
                  .replace(/^./, str => str.toUpperCase())
                  .trim();

                return (
                  <div key={key} className={styles.dataItem}>
                    <span className={styles.dataKey}>{formattedKey}:</span>
                    <span className={styles.dataValue}>
                      {typeof value === 'boolean' ? (value ? 'Yes' : 'No') : String(value)}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        )} */}

        <button className={styles.okButton} onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
};

export default SuccessModal;
